// pdfjs-dist 5.x calls Promise.withResolvers, which is absent on Chrome <119, Firefox <121
// and Safari <17.4 — still in use on locked-down corporate machines (PSCS-975).
// Without this the invoice PDF viewer takes the whole app down.
if (typeof (Promise as any).withResolvers !== 'function') {
  (Promise as any).withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;

    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });

    return { promise, resolve, reject };
  };
}

export {};
